<template>
  <div>
    <a-modal
      width="1400px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="新增预制订单"
      :body-style="{ color: 'red' }"
      @ok="handleSubmit"
    >
      <a-form
        ref="formRef"
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 15 }"
        class="simiot-compact-form"
        @submit="handleSubmit"
      >
        <a-row>
          <a-col :span="12">
            <span>订购信息</span>

            <a-form-item label="客户名称" v-if="isNeedChooseAgent">
              <a-select
                @change="selectAgent"
                v-decorator="['agent_id', {
                  rules: [{ required: true, message: '请选择客户名称' }
                  ]
                }]"
                :show-arrow="false"
                show-search
                allow-clear
                :filter-option="false"
                :not-found-content="loadingAgentOptions ? undefined : null"
                placeholder="输入客户名称加载选项"
                @search="fetchAgentOptions"
                :loading="loadingAgentOptions"
              >
                <a-spin v-if="loadingAgentOptions" slot="notFoundContent" size="small" />
                <a-select-option
                  v-for="option in agentOptions"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="订单类型">
              <a-select
                @change="selectAgentPreOrderType"
                :loading="loadingAgentPreOrderTypeOptions"
                show-search
                :filter-option="filterOption"
                v-decorator="[
                  'order_type_id',
                  { rules: [{ required: true, message: '请选择订单类型' }] },
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="record in agentPreOrderTypeOptions"
                  :key="record.sub_type_slug"
                  :value="record.id"
                >
                  {{ record.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="产品类型">
              <a-select
                @change="selectProductType"
                :loading="loadingProductTypeOptions"
                show-search
                :filter-option="filterOption"
                v-decorator="[
                  'product_type_id',
                  { rules: [{ required: true, message: '请选择产品类型' }] },
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="record in productTypeOptions"
                  :key="record.sub_type_slug"
                  :value="record.id"
                >
                  {{ record.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <!--分割线-->
            <a-divider />

            <span>配送信息</span>

            <a-form-item label="配送类型">
              <a-select
                :loading="loadingDeliveryTypeOptions"
                show-search
                :filter-option="filterOption"
                v-decorator="[
                  'delivery_type_id',
                  { rules: [{ required: true, message: '请选择配送类型' }] },
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="record in deliveryTypeOptions"
                  :key="record.sub_type_slug"
                  :value="record.id"
                >
                  {{ record.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="配送时效">
              <a-select
                :loading="loadingDeliveryTimeTypeOptions"
                show-search
                :filter-option="filterOption"
                v-decorator="[
                  'delivery_time_type_id',
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="record in deliveryTimeTypeOptions"
                  :key="record.id"
                  :value="record.id"
                >
                  {{ record.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="配送费用">
              <a-select
                :loading="loadingDeliveryFeeTypeOptions"
                show-search
                :filter-option="filterOption"
                v-decorator="[
                  'delivery_fee_type_id',
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="record in deliveryFeeTypeOptions"
                  :key="record.id"
                  :value="record.id"
                >
                  {{ record.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="配送地址">
              <a-input-group compact>
                <a-form-item :style="{ display: 'inline-block', width: '75%', marginBottom: 0 }">
                  <a-select
                    :loading="loadingDeliveryAddressOptions"
                    show-search
                    :filter-option="filterOption"
                    v-decorator="[
                      'delivery_address_id',
                    ]"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="record in deliveryAddressOptions"
                      :key="record.id"
                      :value="record.id"
                      :title="record.receiver + ' ' + record.phone_number + ' ' + record.address_detail"
                    >
                      {{ record.receiver + " " + record.phone_number + " " + record.address_detail }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item :style="{ display: 'inline-block', width: '22%', marginLeft: '5px', float: 'right' }">
                  <a-button type="primary" :disabled="isCanAddAddress" @click="showNewDeliveryAddressModal">新增</a-button>
                </a-form-item>
              </a-input-group>
            </a-form-item>

            <a-form-item label="配送备注">
              <a-textarea
                v-decorator="['delivery_remark', {
                  rules: [
                    { max: 200, message: '最多200个字符' },
                  ]
                }]"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>

            <!--分割线-->
            <a-divider />
            <span>发票信息</span>

            <a-form-item label="开票信息">
              <a-input-group compact>
                <a-form-item :style="{ display: 'inline-block', width: '75%', marginBottom: 0 }">
                  <a-select
                    :loading="loadingInvoiceInfoOptions"
                    show-search
                    :filter-option="filterOption"
                    v-decorator="[
                      'invoice_info_id',
                    ]"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="record in invoiceInfoOptions"
                      :key="record.id"
                      :value="record.id"
                      :title="record.account_name + ' ' + record.invoice_no"
                    >
                      {{ record.account_name + " " + record.invoice_no }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item :style="{ display: 'inline-block', width: '22%', marginLeft: '5px', float: 'right' }">
                  <a-button type="primary" :disabled="isCanAddInvoiceInfo" @click="showNewInvoiceInfoModal">新增</a-button>
                </a-form-item>
              </a-input-group>
            </a-form-item>

            <a-form-item label="开票方">
              <a-select
                :loading="loadingInvoiceFromOptions"
                show-search
                :filter-option="filterOption"
                v-decorator="[
                  'invoice_from_id',
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="record in invoiceFromOptions"
                  :key="record.id"
                  :value="record.id"
                >
                  {{ record.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="开票类目">
              <a-select
                :loading="loadingInvoiceCategoryOptions"
                show-search
                :filter-option="filterOption"
                v-decorator="[
                  'invoice_category_id',
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="record in invoiceCategoryOptions"
                  :key="record.id"
                  :value="record.id"
                >
                  {{ record.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="税率">
              <a-select
                :loading="loadingInvoiceRateOptions"
                show-search
                :filter-option="filterOption"
                v-decorator="[
                  'invoice_rate_id',
                ]"
                placeholder="请选择税率"
              >
                <a-select-option
                  v-for="record in invoiceRateOptions"
                  :key="record.id"
                  :value="record.id"
                >
                  {{ record.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="开票备注">
              <a-textarea
                v-decorator="['invoice_remark', {
                  rules: [
                    { max: 200, message: '最多200个字符' },
                  ]
                }]"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <span>产品信息</span>

            <div v-if="currentAgentPreOrderType === 'purchase' && currentProductType === 'sim_card'">
              <sim-card-form ref="simCardForm" :form="form" :agent-id="agentId" :product-type-id="currentProductTypeId" />
            </div>

            <div v-else-if="currentAgentPreOrderType === 'purchase' && currentProductType === 'cpe'">
              <cpe-form ref="cpeForm" :form="form" :agent-id="agentId" :product-type-id="currentProductTypeId" />
            </div>

            <div v-else-if="currentAgentPreOrderType === 'purchase' && currentProductType === 'comm_module'">
              <comm-module-form ref="commModuleForm" :form="form" :agent-id="agentId" :product-type-id="currentProductTypeId" />
            </div>

            <div v-else-if="currentAgentPreOrderType === 'purchase' && currentProductType === 'other'">
              <other-form ref="otherForm" :form="form" :agent-id="agentId" :product-type-id="currentProductTypeId" />
            </div>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <!-- 新增配送地址模态框 -->
    <new-receive-address
      v-if="isShowNewDeliveryAddressModal"
      :visible.sync="isShowNewDeliveryAddressModal"
      :agent-id="this.agentId"
      @completed="fetchDeliveryAddressOptions"
    />

    <!-- 新增开票信息模态框 -->
    <new-invoice-info
      v-if="isShowNewInvoiceInfoModal"
      :visible.sync="isShowNewInvoiceInfoModal"
      :agent-id="this.agentId"
      @completed="fetchInvoiceInfoOptions"
    />
  </div>
</template>
<script>

import { findAgentOptions } from '@/api/agent'
import { findAgentPreOrder } from '@/api/agent_pre_order'
import { createAgentPreOrderItem } from '@/api/agent_pre_order_item'
import { findCommonTypeOptions } from '@/api/common_type'
import { findReceiveAddresses } from '@/api/receive_address'
import { findInvoiceInfos } from '@/api/invoice_info'

export default {
  name: 'NewAgentPreOrderItem',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  components: {
    SimCardForm: () => import('@/views/agent_pre_order_items/sim_card/New'),
    CpeForm: () => import('@/views/agent_pre_order_items/cpe/New'),
    CommModuleForm: () => import('@/views/agent_pre_order_items/comm_module/New'),
    OtherForm: () => import('@/views/agent_pre_order_items/other/New'),
    NewReceiveAddress: () => import('@/views/receive_addresses/New'),
    NewInvoiceInfo: () => import('@/views/invoice_infos/New')
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'agent_pre_order_item' }),
      submitting: false,
      isNeedChooseAgent: true,
      loadingAgentPreOrder: false,
      loadingAgentOptions: false,
      agentOptions: [],
      agentId: '',
      agentPreOrderTypeOptions: [],
      loadingAgentPreOrderTypeOptions: true,
      currentAgentPreOrderType: '',
      productTypeOptions: [],
      loadingProductTypeOptions: true,
      currentProductType: '',
      currentProductTypeId: 0,
      deliveryTypeOptions: [],
      loadingDeliveryTypeOptions: true,
      deliveryTimeTypeOptions: [],
      loadingDeliveryTimeTypeOptions: true,
      deliveryFeeTypeOptions: [],
      loadingDeliveryFeeTypeOptions: true,
      deliveryAddressOptions: [],
      loadingDeliveryAddressOptions: false,
      isCanAddAddress: true,
      isShowNewDeliveryAddressModal: false,
      invoiceInfoOptions: [],
      loadingInvoiceInfoOptions: false,
      isCanAddInvoiceInfo: true,
      isShowNewInvoiceInfoModal: false,
      invoiceFromOptions: [],
      loadingInvoiceFromOptions: true,
      invoiceCategoryOptions: [],
      loadingInvoiceCategoryOptions: true,
      invoiceRateOptions: [],
      loadingInvoiceRateOptions: true,
      loadingLastRemarks: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    if (this.id > 0) {
      this.isNeedChooseAgent = false
      this.fetchAgentPreOrder()
    }

    this.fetchAgentPreOrderTypeOptions()
    this.fetchProductTypeOptions()
    this.fetchDeliveryTypeOptions()
    this.fetchDeliveryTimeTypeOptions()
    this.fetchDeliveryFeeTypeOptions()
    this.fetchInvoiceFromOptions()
    this.fetchInvoiceCategoryOptions()
    this.fetchInvoiceRateOptions()
  },
  methods: {
    // TODO
    fetchAgentPreOrder() {
      this.loadingAgentPreOrder = true
      findAgentPreOrder(this.id).then(res => {
        if (res.code === 0) {
          this.loadingAgentPreOrder = false

          this.selectAgent(res.data.agent_id)
        }
      })
    },

    // 加载所属用户选项数据
    fetchAgentOptions(name) {
      if (!this.$lodash.trim(name)) {
        return
      }

      this.loadingAgentOptions = true
      findAgentOptions({ name: name }).then(res => {
        if (res.code === 0) {
          this.agentOptions = res.data
          this.loadingAgentOptions = false
        }
      })
    },

    // 选择客户
    selectAgent(value) {
      this.agentId = value
      this.isCanAddAddress = false
      this.isCanAddInvoiceInfo = false

      this.fetchDeliveryAddressOptions()
      this.fetchInvoiceInfoOptions()

      this.fetchProductInfo()
    },

    // 加载预制订单类型
    fetchAgentPreOrderTypeOptions() {
      this.loadingAgentPreOrderTypeOptions = true
      findCommonTypeOptions('agent_pre_order').then((res) => {
        if (res.code === 0) {
          this.agentPreOrderTypeOptions = res.data
        }
        this.loadingAgentPreOrderTypeOptions = false
      })
    },

    selectAgentPreOrderType(value, e) {
      this.currentAgentPreOrderType = e.key

      this.fetchProductInfo()
    },

    // 加载产品类型
    fetchProductTypeOptions() {
      this.loadingProductTypeOptions = true
      findCommonTypeOptions('product_type').then((res) => {
        if (res.code === 0) {
          this.productTypeOptions = res.data
        }
        this.loadingProductTypeOptions = false
      })
    },

    selectProductType(value, e) {
      this.currentProductType = e.key
      this.currentProductTypeId = value

      this.fetchProductInfo()
    },

    // 加载配送类型
    fetchDeliveryTypeOptions() {
      this.loadingDeliveryTypeOptions = true
      findCommonTypeOptions('delivery_type').then((res) => {
        if (res.code === 0) {
          this.deliveryTypeOptions = res.data
        }
        this.loadingDeliveryTypeOptions = false
      })
    },

    // 加载配送时效类型
    fetchDeliveryTimeTypeOptions() {
      this.loadingDeliveryTypeTimeOptions = true
      findCommonTypeOptions('delivery_time_type').then((res) => {
        if (res.code === 0) {
          this.deliveryTimeTypeOptions = res.data
        }
        this.loadingDeliveryTimeTypeOptions = false
      })
    },

    // 加载配送费用类型
    fetchDeliveryFeeTypeOptions() {
      this.loadingDeliveryFeeTypeOptions = true
      findCommonTypeOptions('delivery_fee_type').then((res) => {
        if (res.code === 0) {
          this.deliveryFeeTypeOptions = res.data
        }
        this.loadingDeliveryFeeTypeOptions = false
      })
    },

    // 加载配送费用地址
    fetchDeliveryAddressOptions() {
      this.loadingDeliveryAddressOptions = true
      findReceiveAddresses({ agent_id: this.agentId }).then((res) => {
        if (res.code === 0) {
          this.deliveryAddressOptions = res.data
        }
        this.loadingDeliveryAddressOptions = false
      })
    },

    // 显示新增弹窗
    showNewDeliveryAddressModal() {
      this.isShowNewDeliveryAddressModal = true
    },

    // 加载发票信息
    fetchInvoiceInfoOptions() {
      this.loadingInvoiceInfoOptions = true
      findInvoiceInfos({ agent_id: this.agentId }).then((res) => {
        if (res.code === 0) {
          this.invoiceInfoOptions = res.data
        }
        this.loadingInvoiceInfoOptions = false
      })
    },

    // 显示新增弹窗
    showNewInvoiceInfoModal() {
      this.isShowNewInvoiceInfoModal = true
    },

    // 加载发票方
    fetchInvoiceFromOptions() {
      this.loadingInvoiceFromOptions = true
      findCommonTypeOptions('invoice_from').then((res) => {
        if (res.code === 0) {
          this.invoiceFromOptions = res.data
        }
        this.loadingInvoiceFromOptions = false
      })
    },

    // 加载发票目录类型
    fetchInvoiceCategoryOptions() {
      this.loadingInvoiceCategoryOptions = true
      findCommonTypeOptions('invoice_category').then((res) => {
        if (res.code === 0) {
          this.invoiceCategoryOptions = res.data
        }
        this.loadingInvoiceCategoryOptions = false
      })
    },

    // 加载发票税率
    fetchInvoiceRateOptions() {
      this.loadingInvoiceRateOptions = true
      findCommonTypeOptions('invoice_rate').then((res) => {
        if (res.code === 0) {
          this.invoiceRateOptions = res.data
        }
        this.loadingInvoiceRateOptions = false
      })
    },

    // 触发获取产品信息
    fetchProductInfo() {
      if (this.currentAgentPreOrderType === 'purchase' && this.currentProductType === 'sim_card') {
        if (this.agentId > 0) {
          // 获取客户套餐
          setTimeout(() => {
            this.$refs.simCardForm.fetchAgentProductOptions(this.agentId)
          }, 300)
        }
      } else {

      }
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const data = {
            agent_id: this.agentId,
            agent_pre_order_id: this.id,
            ...values
          }
          createAgentPreOrderItem(data).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }

            this.submitting = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
